import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const usePaidStatus = () => {
  const [values, setValues] = useState(null);
  const { t } = useTranslation();

  if (!values) {
    setValues([
      { label: t('GENERAL.yes'), value: 'true' },
      { label: t('GENERAL.no'), value: 'false' },
    ]);
  }

  return values;
};

export { usePaidStatus };
